var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22308_3094)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7499 2.89999C13.2193 2.89999 13.5999 3.28055 13.5999 3.74999C13.5999 4.18333 13.2756 4.54092 12.8565 4.59337L12.7499 4.59999H4.5999V19.4H19.3999V11.25C19.3999 10.8167 19.7242 10.4591 20.1433 10.4066L20.2499 10.4C20.6832 10.4 21.0408 10.7243 21.0933 11.1434L21.0999 11.25V19.5C21.0999 20.3346 20.4609 21.0199 19.6455 21.0935L19.4999 21.1H4.4999C3.66534 21.1 2.98001 20.461 2.90644 19.6456L2.8999 19.5V4.49999C2.8999 3.66543 3.53886 2.9801 4.35427 2.90653L4.4999 2.89999H12.7499ZM17.3989 2.39895C17.7308 2.06701 18.269 2.06701 18.6009 2.39895L21.6009 5.39895C21.9329 5.7309 21.9329 6.26909 21.6009 6.60103L12.6009 15.601C12.4415 15.7604 12.2253 15.85 11.9999 15.85H8.9999C8.53046 15.85 8.1499 15.4694 8.1499 15V12C8.1499 11.7746 8.23946 11.5584 8.39886 11.399L17.3989 2.39895ZM15.7489 6.45199L9.8499 12.352V14.15H11.6459L17.5459 8.24899L15.7489 6.45199ZM17.9999 4.20299L16.9519 5.24899L18.7489 7.04599L19.7969 5.99999L17.9999 4.20299Z",
    fill: "#587E85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22308_3094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesHeaderIcon);
export default __webpack_public_path__ + "static/media/notes_header_icon.5db5873e115e43f6c669e3b1b176ebd7.svg";
export { ForwardRef as ReactComponent };